import React, { useState, useRef } from 'react';
import { StarIcon } from 'lucide-react';
const TESTIMONIALS_DATA = [{
  quote: "Finally. Something that actually respects the legacy. I've bought anniversary merch before. Keychains, Blu-rays with the same bonus features recycled every five years. This is different. Back In Time reads like it was written by someone who genuinely understands what this film meant, not just as entertainment, but as a cultural moment. I'm 52 years old and I still got chills reading the chapter on the clock tower sequence. Worth every penny.",
  name: 'David M., 52',
  location: 'Software Engineer | Portland, Oregon, USA'
}, {
  quote: "I cried reading 'Behind the Clock Tower.' Actual tears. I wasn't expecting to be emotional about a book on filmmaking. But when they described Michael J. Fox working 18-hour days between sets, the dedication these people had — it hit me hard. My dad took me to see this film in 1985. He passed three years ago. Reading this felt like honoring both of them.",
  name: 'Karen T., 58',
  location: 'Retired Teacher | Manchester, UK'
}, {
  quote: "My 16-year-old watched it with me after I showed her this collection. I've been trying to get my daughter to understand why Back to the Future isn't just 'an old movie.' After she read a few sections of Time. Imagination. Destiny. with me, she watched the trilogy start to finish. Unprompted. That's the power of this collection, it gives you the language to explain why this film matters to people who weren't there.",
  name: 'James R., 47',
  location: 'Architect | Toronto, Canada'
}, {
  quote: "The best anniversary release in a decade. No contest. I've been a BTTF fan my entire adult life and I'm deeply skeptical of anniversary marketing. Cash grabs everywhere. This is not that. Back In Time is genuinely researched, intelligently written, and emotionally honest. The philosophical analysis in Volume 4 alone is worth the price of the entire collection.",
  name: 'Michael B., 61',
  location: 'University Lecturer | Edinburgh, Scotland'
}, {
  quote: "Read it in one sitting. Couldn't stop. I downloaded the digital collection on a Friday night thinking I'd skim the first volume. Looked up at 2am and I was halfway through Volume 3. The production stories in Behind the Clock Tower are absolutely riveting, details I'd never read anywhere else. The DeLorean stories alone are worth it.",
  name: 'Rachel H., 44',
  location: 'Marketing Director | Sydney, Australia'
}, {
  quote: "This is the document I didn't know I needed. There's something strange about loving a film for 40 years and never being able to fully explain why. This collection gave me the vocabulary. The chapter on why the film resonates across generations isn't just insightful — it's validating. Like someone finally said out loud what we all felt but couldn't articulate.",
  name: 'Thomas W., 55',
  location: 'Small Business Owner | Chicago, Illinois, USA'
}, {
  quote: "Gifted the hardcover to my brother. He called me the next day. My brother and I saw Back to the Future together when we were kids. We both remembered exactly where we were sitting in the theater. I ordered the hardcover upgrade as his birthday gift, and he called me the day it arrived, genuinely emotional. We ended up talking for two hours about the film. Best gift I've given in years.",
  name: 'Sandra L., 50',
  location: 'Registered Nurse | Calgary, Canada'
}, {
  quote: "Skeptical at first. Completely wrong to be. I'll be honest, I almost didn't buy this because I've been burned before by anniversary content that turned out to be repackaged Wikipedia articles. This is not that. The writing is sharp, the research is deep, and the emotional framing throughout is genuine. Whoever wrote this actually loves the film.",
  name: 'Andrew F., 48',
  location: 'IT Project Manager | Melbourne, Australia'
}, {
  quote: "The section on the Eric Stoltz recasting alone is worth it. I'd heard the basic story before, but the level of detail in Behind the Clock Tower goes far beyond anything I'd read. The production decisions that almost killed the movie, the pressure on everyone involved, it reads like a thriller. And then the film comes out and becomes one of the greatest of all time. Remarkable story.",
  name: 'Christopher D., 53',
  location: 'Film Professor | Boston, Massachusetts, USA'
}, {
  quote: "I've rewatched the trilogy 20+ times. I learned things I never knew. That should tell you something about the depth of this collection. These aren't surface-level fun facts. The production history, the cultural analysis, the philosophical chapters, it's a serious, respectful treatment of a film that deserves exactly that. I'll be reading this again.",
  name: 'Fiona M., 46',
  location: 'Graphic Designer | Dublin, Ireland'
}, {
  quote: "My husband and I read it together. Best purchase we've made in months. We both grew up on this film but from different countries, he's American, I'm British. It was fascinating to compare how differently we each experienced the film culturally, and then read how universally it landed worldwide. Time. Imagination. Destiny. made us both feel seen in a way we didn't expect.",
  name: 'Patricia & Alan G., 56 & 59',
  location: 'Retired Educators | Phoenix, Arizona, USA'
}, {
  quote: "I was worried this would be AI-generated filler. It absolutely is not. That concern crossed my mind when I first saw it, I'm in my 50s, not naive. But two pages in, it was obvious this was written by people who know the film deeply and care about doing it justice. The specificity of the production details, the quality of the cultural analysis, this is real work. Real love for the film.",
  name: 'Robert K., 57',
  location: 'Civil Engineer | Denver, Colorado, USA'
}, {
  quote: "The 40 quotes in 'Great Scott!' made me laugh and cry on the same page. That's an achievement. Volume 3 is the emotional heart of the collection for me. Forty perspectives on forty years, some funny, some devastating, some deeply philosophical. The range of voices is incredible. I read it in one afternoon and felt strangely lighter afterward. Like something had been resolved.",
  name: 'Diane A., 62',
  location: 'Librarian | Auckland, New Zealand'
}, {
  quote: "This is what I wanted to give my son on his 18th birthday. He'd never seen Back to the Future. I sat him down, we watched all three films, and then I handed him the digital collection. He spent the next week reading it between classes. He texted me yesterday: 'Dad, I finally get why you love this movie so much.' That's the whole point, isn't it?",
  name: 'Mark S., 51',
  location: 'Sales Manager | Houston, Texas, USA'
}, {
  quote: "40 years later, this film still has more to say. So does this collection. I was 15 when I first saw it in the cinema. I'm 55 now. And reading Back In Time reminded me that genuine art doesn't expire, it deepens. This collection doesn't just celebrate the film. It argues for why it matters. And it makes that argument beautifully. I'm grateful someone did this properly.",
  name: 'Jonathan P., 55',
  location: 'Writer | Vancouver, Canada'
}];
export const TestimonialsInt02 = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setStartX(e.pageX - (scrollRef.current?.offsetLeft || 0));
    setScrollLeft(scrollRef.current?.scrollLeft || 0);
  };
  const handleTouchStart = (e: React.TouchEvent) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - (scrollRef.current?.offsetLeft || 0));
    setScrollLeft(scrollRef.current?.scrollLeft || 0);
  };
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !scrollRef.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging || !scrollRef.current) return;
    const x = e.touches[0].pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };
  const handleEnd = () => {
    setIsDragging(false);
  };
  const duplicatedTestimonials = [...TESTIMONIALS_DATA, ...TESTIMONIALS_DATA];
  return <section className="py-4 md:py-6 overflow-hidden" style={{
    backgroundColor: '#0B0B0B'
  }} data-id="element-536">
      <div className="mb-4 px-4" data-id="element-537">
        <h2 className="text-2xl md:text-3xl font-bold text-center font-future tracking-wide text-white" data-id="element-538">
          What Real Fans Are Saying
        </h2>
      </div>

      <div className="relative w-full overflow-hidden cursor-grab active:cursor-grabbing" onMouseDown={handleMouseDown} onMouseLeave={handleEnd} onMouseUp={handleEnd} onMouseMove={handleMouseMove} onTouchStart={handleTouchStart} onTouchEnd={handleEnd} onTouchMove={handleTouchMove} data-id="element-539">
        <div className="absolute left-0 top-0 bottom-0 w-12 md:w-24 z-10 pointer-events-none bg-gradient-to-r from-[#0B0B0B] to-transparent" data-id="element-540" />
        <div className="absolute right-0 top-0 bottom-0 w-12 md:w-24 z-10 pointer-events-none bg-gradient-to-l from-[#0B0B0B] to-transparent" data-id="element-541" />

        <div ref={scrollRef} className="flex overflow-x-hidden no-scrollbar" data-id="element-542">
          <div className={`flex gap-5 w-max ${isDragging ? '' : 'animate-marquee'}`} data-id="element-543">
            {duplicatedTestimonials.map((testimonial, index) => <div key={index} className="p-5 rounded-xl flex flex-col flex-shrink-0 w-[320px] md:w-[350px] select-none" style={{
            backgroundColor: '#111111',
            border: '1px solid rgba(255,108,0,0.15)'
          }} data-id="element-544">
                <div className="flex gap-0.5 mb-3" data-id="element-545">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-yellow-400" data-id="element-546" />)}
                </div>
                <p className="text-white/75 text-sm leading-relaxed mb-4 flex-1 italic" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-547">
                  "{testimonial.quote}"
                </p>
                <div data-id="element-548">
                  <p className="text-white font-semibold text-sm" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-549">
                    {testimonial.name}
                  </p>
                  <p className="text-white/40 text-xs" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-550">
                    {testimonial.location}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};